import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { exchangeGoogleSession } from "@/lib/api";

export default function GoogleCallback() {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      // Emergent returns session_id in URL fragment (#session_id=...) per their auth contract.
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
      const sessionId = params.get("session_id") || new URLSearchParams(window.location.search).get("session_id");
      if (!sessionId) {
        setError("Missing session_id in callback URL");
        return;
      }
      try {
        const u = await exchangeGoogleSession(sessionId);
        if (cancelled) return;
        setUser(u);
        await refresh();
        navigate("/app", { replace: true });
      } catch (err) {
        if (!cancelled) {
          const detail = err?.response?.data?.detail;
          setError(typeof detail === "string" ? detail : "Google sign-in failed.");
        }
      }
    }
    run();
    return () => { cancelled = true; };
  }, [navigate, setUser, refresh]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-background text-center">
      <div className="serif text-2xl text-primary">Completing Google sign-in…</div>
      <div className="text-sm text-muted-foreground mt-2">Hold tight while we verify your session.</div>
      {error && (
        <div className="mt-6 max-w-md rounded-sm border border-destructive/30 bg-destructive/5 text-destructive px-4 py-3 text-sm">
          {error}
        </div>
      )}
    </div>
  );
}
